/**
 * Karaoke del REPLAY de una burbuja del coach.
 *
 * El karaoke VIVO lo maneja `@orborix/voice-client` contra el reloj del
 * `AudioPlayer` del WS (ver `karaokeBuffer.ts`). Cuando la burbuja se cierra,
 * ese buffer se limpia — por eso apretar play de nuevo reproducía el audio sin
 * marcar nada. El replay usa en cambio el reloj del `<audio>` que reproduce el
 * blob, contra el alignment congelado del turno (`VoiceMessage.alignment`) o el
 * que devuelve `/speak` con `timestamps:true` en la resíntesis.
 */

/**
 * Índice del carácter que suena en `posMs`, o -1 si no hay alignment.
 *
 * Espeja `getKaraokeCharIndex` del cliente de voz: antes del primer carácter
 * devuelve 0 (el resaltado arranca en la primera palabra en vez de parpadear),
 * y a partir de ahí el último carácter cuyo inicio ya pasó. `startsMs` viene
 * ordenado de forma creciente, así que el barrido desde el final corta en el
 * primer candidato.
 */
export function charIndexAt(startsMs: ReadonlyArray<number>, posMs: number): number {
  if (startsMs.length === 0) return -1;
  const first = startsMs[0] ?? 0;
  if (posMs < first) return 0;
  for (let i = startsMs.length - 1; i >= 0; i -= 1) {
    const start = startsMs[i];
    if (start !== undefined && posMs >= start) return i;
  }
  return -1;
}

/**
 * Alignment utilizable para el replay, o `null` si no hay. Con Gemini TTS
 * `/speak { timestamps:true }` devuelve `startsMs: []` (el provider no da
 * tiempos por carácter) y los turnos en vivo no dejan snapshot: sin alignment
 * el replay suena sobre texto plano, sin correr el karaoke.
 */
export function replayAlignment(
  startsMs: ReadonlyArray<number> | null | undefined,
): ReadonlyArray<number> | null {
  return startsMs && startsMs.length > 0 ? startsMs : null;
}
